<template>
  <div>
    <!-- <left-menu-admin
      ref="modal"
      menuActive="0"
      :sessionData="session"
    ></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="40%">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click=";(dialogAdd = false), clearData()"
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v-img-margit"
                        :src="require('@/assets/qricon.png')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v_text_add"
                        :src="require('@/assets/Grouptitle.png')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <v-form ref="form_add" v-model="validAdd" lazy-validation>
                    <v-col cols="12">
                      <v-row style="height: 65px">
                        <v-select
                          v-model="formAdd.packageId"
                          :items="packageId"
                          dense
                          outlined
                          :rules="[rules.required]"
                          label="แพคเกจ"
                        ></v-select>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row style="height: 65px">
                        <v-text-field
                          v-model="formAdd.chkQRCode"
                          dense
                          outlined
                          label="จำนวนที่สร้าง"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row style="height: 65px">
                        <v-select
                          v-model="formAdd.masBranchID"
                          :items="dataBranch"
                          label="สาขา"
                          dense
                          outlined
                          :rules="[rules.required]"
                        ></v-select>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      dark
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      @click="addData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- QR Code -->
          <v-dialog v-model="dialogViewAdd" persistent max-width="40%">
            <v-card>
              <v-card-title class="text-center">
                Scan เพื่อรับแพคเกจ
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="session.data.logo" max-width="50"></v-img>
                      <span class="mr-16 shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description" id="text_a"
                            >วันที่
                            {{
                              format_dateNotime(formUpdate.CREATE_DATE)
                            }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col class="text-center">
                      <!-- {{ formUpdate.qrCodeURL }} -->
                      <qrcode-vue
                        style="margin-top: 50px"
                        :value="formUpdate.qrCodeURL"
                        :size="size"
                        level="H"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center"
                      ><span class="summary" id="text_a"
                        >แพคเกจ {{ formUpdate.packageName }}</span
                      ></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center"
                      ><span class="point s-4" id="text_b">
                        จำนวน {{ formUpdate.packageCount }} ครั้ง</span
                      ></v-col
                    >
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <span class="description" id="text_a">ราคาแพคเกจ: </span>
                    </v-col>
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formUpdate.packagePrice }} บาท</span
                      >
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 1px">
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >+ {{ formUpdate.packagePoint }} คะแนน</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="blue darken-1"
                  @click="
                    ;(dialogAdd = false),
                      (dialogViewAdd = false),
                      clearData(),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId + '&status=waiting'
                      ),
                      getPackage()
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end view -->

          <!-- view QR Code -->
          <v-dialog v-model="dialogView" persistent max-width="40%">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        ;(dialogView = false),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          ),
                          getPackage()
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="session.data.logo" max-width="50"></v-img>
                      <span class="mr-16 shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description" id="text_a"
                            >วันที่
                            {{ format_date(formUpdate.CREATE_DATE) }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col class="text-center"
                      >{{ formUpdate.qrCodeURL }}
                      <qrcode-vue
                        style="margin-top: 50px"
                        :value="formUpdate.qrCodeURL"
                        :size="size"
                        level="H"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center"
                      ><span class="summary" id="text_a"
                        >แพคเกจ {{ formUpdate.packageName }}</span
                      ></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center"
                      ><span class="point s-4" id="text_b">
                        จำนวน {{ formUpdate.packageCount }} ครั้ง
                      </span></v-col
                    >
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <span class="description" id="text_a">ราคาแพคเกจ: </span>
                    </v-col>
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formUpdate.packagePrice }} บาท</span
                      >
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 1px">
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formUpdate.packagePoint }} คะแนน</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="#173053"
                  dark
                  @click="
                    ;(dialogView = false),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId + '&status=waiting'
                      ),
                      getPackage()
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end view -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        ;(dialogEdit = false),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          )
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v_text_edit"
                        :src="require('@/assets/GroupEditTitle.svg')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <div class="text-center" style="margin-top: 15px">
                    <qrcode-vue
                      :value="formUpdate.qrCodeURL"
                      :size="size"
                      level="H"
                    ></qrcode-vue>
                  </div>
                  <v-form
                    ref="form_update"
                    v-model="validUpdate"
                    lazy-validation
                  >
                    <v-col cols="12">
                      <v-row style="height: 65px">
                        <v-select
                          v-model="formUpdate.packageId"
                          :items="packageId"
                          dense
                          outlined
                          :rules="[rules.required]"
                          label="แพคเกจ"
                        ></v-select>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="แพคเกจ"
                        v-model="formUpdate.packageName"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- view cf -->
          <v-dialog v-model="dailogViewRedeem" persistent max-width="400">
            <v-card>
              <v-card-title>
                <span class="headline">ยืนยัน</span>
              </v-card-title>
              <v-card-text v-if="!statusViewRedeem">
                <v-alert dense outlined type="error">
                  <strong>Data not found</strong>
                </v-alert>
              </v-card-text>
              <v-card-text v-if="statusViewRedeem">
                <v-container>
                  <b>ข้อมูลแพคเกจ</b>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="formView.packageImg" max-width="90"></v-img>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description"
                            ><b>แพคเกจ :</b> {{ formView.packageName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description">
                            จำนวนครั้ง : {{ formView.amount }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description">
                            จำนวนที่เหลือ : {{ formView.balanceAmount }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- <br />
                  <b>ข้อมูลลูกค้า</b>
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description"
                            ><b>ชื่อลูกค้า :</b> {{ formView.lineName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description"
                            ><b>ระดับ :</b> {{ formView.levelName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description"
                            ><b>คะแนนทั้งหมด :</b>
                            {{ formView.currentPoint }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                    <v-col class="text-center">
                      <v-img :src="formView.linePicture" max-width="90"></v-img>
                    </v-col>
                  </v-row> -->
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="closeViewRedeem()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="green darken-1"
                  v-if="statusViewRedeem"
                  @click="updateUsePackage()"
                >
                  <v-icon left> mdi-content-save-all</v-icon>
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    {{ formatNumber(item.amount) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          small
                          @click.stop="
                            ;(dialogView = true),
                              getDataById(item),
                              validate('View')
                          "
                        >
                          <v-icon dark> mdi-qrcode </v-icon>
                        </v-btn>
                      </template>
                      <span>เปิด Qr code</span>
                    </v-tooltip>
                    <!-- <v-btn
                      class="btn-color"
                      fab
                      small
                      @click.stop="
                        ;(dialogEdit = true),
                          getDataById(item),
                          validate('UPDATE')
                      "
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          small
                          @click.stop="
                            ;(dialogDelete = true), getDataById(item)
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    QrcodeStream
  },
  data () {
    return {
      PK: '',
      path: '/packageQRcode/', // Path Model
      returnLink: '/Master/PackageQRcode',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ซื้อแพคเกจ',
          disabled: false,
          href: '/Master/PackageQRcode'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      size: 180, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogView: false,
      dialogViewAdd: false,
      dailogViewRedeem: false,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      searchAll1: '',
      formView: {
        packageImg: '',
        packageName: '',
        rewardName: '',
        rewardSubName: '',
        rewardPictureUrl: ''
      },
      formAdd: {
        packageId: '',
        chkQRCode: 1,
        token: '',
        liffId: '',
        status: 'waiting',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        masBranchID: '',
        CREATE_DATE: ''
      },
      formUpdate: {},
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ชื่อแพคเกจ', value: 'packageName' },
        { text: 'จำนวนครั้งที่ใช้ได้', value: 'packageCount' },
        { text: 'ราคาแพคเกจ', value: 'packagePrice' },
        { text: 'คะแนนที่ได้ในแต่ละครั้ง', value: 'packagePoint' },
        { text: 'รายละเอียดของแพคเกจ', value: 'packageDetail' },
        { text: 'วันหมดอายุของแพคเกจ', value: 'packageExpridate' },
        { text: 'สถานะ', value: 'status' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataBranch: [],
      validAdd: true,
      validUpdate: true,
      statusViewRedeem: false,
      alert: true,
      res: [],
      datasession: '',
      filterItem: [],
      Exchange: '',
      // End Data Table Config
      packageId: [],
      chkQRCode: 1,
      loadingAdd: false,
      loadingEdit: false
    }
  },
  async mounted () {
    // await this.chkViewRedeem()
    if (!this.$session.exists()) {
      this.$router.push(
        '/Core/Login?token=' +
          this.$route.query.token +
          '&userId=' +
          this.$route.query.userId +
          '&shopId=' +
          this.$route.query.shopId
      )
    } else {
      if (this.$route.query.shopId) {
        if (this.$route.query.shopId === this.$session.getAll().data.shopId) {
          this.chkViewRedeem()
        } else {
          this.$swal('ผิดพลาด', 'แพคเกจนี้ไม่ได้อยู่ใน ร้านค้าของคุณ', 'error')
          await this.getDataGlobal(
            this.DNS_IP,
            this.path,
            this.session.data.shopId + '&status=waiting',
            this.returnLink
          )
        }
      } else {
        // this.$swal('ผิดพลาด', 'แพคเกจนี้ไม่ได้อยู่ใน ร้านค้าของคุณ', 'error')
        await this.getDataGlobal(
          this.DNS_IP,
          this.path,
          this.session.data.shopId + '&status=waiting',
          this.returnLink
        )
        await this.getDataBranch()
      }
    }
    this.getPackage()
    this.getDataBranch()
  },
  methods: {
    getDataMonth () {
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.packageExpri !== '') {
          d.packageExpridate = d.packageExpri + ' เดือน'
          this.dataItem.push(d)
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    getPackage () {
      this.packageId = []
      axios
        .get(this.DNS_IP + '/package/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.packageId.toString()
            s.text = d.packageName
            d = s
            console.log(d)
            this.packageId.push(d)
          }
          let month = this.dataItem
          this.dataItem = []
          for (let i = 0; i < month.length; i++) {
            let d = month[i]
            if (d.packageExpri !== '') {
              //   console.log('888', d.packageExpri)
              d.packageExpridate = d.packageExpri + ' เดือน'
              this.dataItem.push(d)
            } else {
              d.packageExpridate = ''
              this.dataItem.push(d)
            }
          }
        })
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID.toString()
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            console.log('masBranch', this.formAdd.masBranchID)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async chkViewRedeem () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            // '/PackageLog/get?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&token=59766306db23aed14ad175eeea5115cf&userId=U35b246f2825895f3fdcc09b72d589f92'
            '/PackageLog/get?shopId=' +
            this.$route.query.shopId +
            '&token=' +
            this.$route.query.token +
            '&userId=' +
            this.$route.query.userId
          //   {
          //     headers: {
          //       'Application-Key': this.$session.getAll().ApplicationKey
          //     }
          //   }
        )
        .then(async response => {
          console.log('data', response)
          if (response.data.status === false) {
            this.dailogViewRedeem = true
            this.statusViewRedeem = false
          } else {
            this.dailogViewRedeem = true
            this.statusViewRedeem = true
            this.formView.packageName = response.data[0].packageName
            this.formView.packageImg = response.data[0].packageImg
            // this.formView.packageId = response.data[0].packageId
            this.formView.packagePoint = response.data[0].packagePoint
            this.formView.amount = response.data[0].amount
            this.formView.balanceAmount = response.data[0].balanceAmount
            // this.formView.currentPoint = response.data[0].currentPoint
            // this.formView.levelName = response.data[0].levelName
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async updateUsePackage () {
      const url1 =
        this.DNS_IP +
        '/use_package/edit?shopId=' +
        this.session.data.shopId +
        '&token=' +
        this.$route.query.token
      let config1 = {
        headers: {
          shopId: this.$route.query.shopId,
          lineId: this.$route.query.userId
        }
      }
      let dt1 = {
        token: this.$route.query.token,
        shopId: this.$route.query.shopId
      }
      await axios.post(url1, dt1, config1).then(async response => {
        if (response.data.status === true) {
          this.$swal({
            title: 'เรียบร้อย',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ตกลง'
          })
            .then(async result => {
              console.log(result)
              // this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.$router.push('/Master/packageQrcode')
              location.reload()
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log(error)
              // this.$router.push('/Tool/CollectQRCode')
              // location.reload()
              // this.dataReady = true
            })
        } else {
          this.$swal('ผิดพลาด', response.data.message, 'error')
          this.$router.push('/Master/packageQrcode')
          location.reload()
        }
      })
    },
    closeViewRedeem () {
      this.$router.push('/Master/packageQRcode')
      location.reload()
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
      console.log('search', search)
    },
    async getDataById (item) {
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'packageQRcodeId',
        item.packageQRcodeId,
        this.returnLink
      )
    },
    async addData () {
      this.dataReady = false
      this.dataShowQR = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.liffId = process.env.VUE_APP_LIFF_ID
          this.formAdd.shopId = this.$session.getAll().data.shopId
          this.formAdd.qrCodeURL = `https://liff.line.me/${process.env.VUE_APP_LIFF_ID}/packageQRcode?shopId=${this.formAdd.shopId}&packageToken=${this.formAdd.Token}`
          delete this.formAdd['CREATE_DATE']
          console.log('formAdd', this.formAdd)
          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAdd)
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              await axios
                .get(
                  this.DNS_IP +
                    '/packageQRcode/get?shopId=' +
                    this.session.data.shopId +
                    '&token=' +
                    response.data.token
                )
                .then(response => {
                  let res = response.data[0]
                  console.log('res', res)
                  Object.assign(this.formUpdate, res)
                  console.log('assign', Object.assign(this.formUpdate, res))
                })
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.formAdd.CREATE_DATE = new Date().toISOString().substr(0, 10)
              this.dialogViewAdd = true
              this.loadingAdd = false
            })
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.packageQRcodeId
          delete this.formUpdate['packageQRcodeId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['CREATE_USER']
          await axios
            .post(this.DNS_IP + this.path + 'edit/' + ID, this.formUpdate)
            .then(async response => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogEdit = false
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId + '&status=waiting',
                this.returnLink
              )
              this.clearData()
            })
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
          this.loadingEdit = false
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('formupdate', this.formUpdate.LAST_USER)
      console.log('DELETE PK : ', this.formUpdate.packageQRcodeId)
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.packageQRcodeId,
        this.session.data.shopId,
        '&status=waiting',
        this.returnLink
      )
    },
    async clearData () {
      this.formAdd.packageId = ''
      this.formAdd.masBranchID = ''
    },
    async clearDataUpdate () {
      this.formUpdate.id = ''
      this.formUpdate.productExchangeRateId = ''
      this.formUpdate.amount = 0
      this.formUpdate.point = 0
      this.formUpdate.token = ''
      this.formUpdate.status = ''
      this.formUpdate.statusMemberCard = 'collect'
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
      this.formUpdate.qrCodeURL = ''
      this.formUpdate.CREATE_DATE = ''
      this.formUpdate.LAST_DATE = ''
      this.formUpdate.branchName = ''
      this.formUpdate.masBranchID = ''
    },
    clearSearch () {
      this.search.masBranchID = ''
      this.search.amount = ''
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 20px;
}
.point {
  font-size: 100px;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#subtext {
  color: #173053;
  font-size: 20px !important;
  font-weight: bold;
}
#margit_vector {
  position: absolute;
  left: 42.03%;
  right: 42.75%;
  top: 15%;
  color: #ffa610;
  size: 50px;
}
#text_awesome {
  position: absolute;
  top: 20%;
  font-size: 40px;
  line-height: 23px;
  font-weight: bold;
  color: #173053;
}
#text_a {
  font-weight: bold;
  color: #173053;
  align-items: center;
  text-align: center;
  font-size: 30px !important;
}
#text_b {
  font-weight: bold;
  font-size: 50px !important;
  align-items: center;
  text-align: center;
  color: #ffa000;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/PackageQRcode.vue